import { render, staticRenderFns } from "./PigProgressMarkers.vue?vue&type=template&id=778fa4fd&scoped=true"
import script from "./PigProgressMarkers.vue?vue&type=script&lang=ts"
export * from "./PigProgressMarkers.vue?vue&type=script&lang=ts"
import style0 from "./PigProgressMarkers.vue?vue&type=style&index=0&id=778fa4fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778fa4fd",
  null
  
)

export default component.exports